import React, { useContext, useState, useRef, useEffect } from "react";
import { ThemeContext } from "../../pages/qcast-logo";
import {
  IoArrowBack,
  IoArrowForward,
  IoStop,
  IoStopCircleOutline,
  IoMicOffOutline,
} from "react-icons/io5";
import { ControlBar, Player } from "video-react";
import "video-react/dist/video-react.css";
import { RecordRTCPromisesHandler } from "recordrtc";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgressbar } from "react-circular-progressbar";
import { recordDuration } from "../../functions/record-functions";

const Respond = (props) => {
  const theme = useContext(ThemeContext);
  const { bg } = theme;
  const [record, setRecord] = useState(false);
  const [recorder, setRecorder] = useState();
  const [blob, setBlob] = useState(null);
  const [stream, setStream] = useState();
  const [startRecording, setStartRecording] = useState(false);
  const [initStream, setinitStream] = useState();
  const videoRef = useRef(null);
  const dispatch = useDispatch();
  const [timer, setTimer] = useState(0);
  const [interval, setIntervals] = useState();

  const currentQcast = useSelector((state) => state.qcast.currentQcast);
  const [isMuted, setIsMuted] = useState(true);

  const [vidInfo, setVidInfo] = useState({});

  const vidRef = useRef(null);

  useEffect(() => {
    if (vidInfo.ended) {
      setIsMuted(false);
      stream.getAudioTracks()[0].enabled = true;
    } else {
      setIsMuted(true);
      if (stream) stream.getAudioTracks()[0].enabled = false;
    }
  }, [vidInfo, currentQcast.currentVidIndex]);

  useEffect(() => {
    (async function () {
      await liveRecord();
    })();

    // subscribe state change
    vidRef.current.subscribeToStateChange(handleVidStateChange);

    return () => {
      if (initStream?.getTracks()) {
        initStream?.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  const handleVidStateChange = (state) => {
    // copy player state to this component's state
    setVidInfo(state);
  };

  const liveRecord = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          width: 1280,
          height: 720,
        },
      });
      setinitStream(stream);
      const video = videoRef.current;
      video.srcObject = stream;
      video.play();
    } catch (err) {
      alert("Device not found!");
      props.back();
    }
  };

  const start = async () => {
    setStartRecording(true);
    vidRef.current.play();
    await liveRecord();
    if (typeof window !== "undefined") {
      const streaming = await navigator.mediaDevices.getUserMedia({
        audio: { deviceId: "communications" },
        video: {
          width: 250,
          height: 250,
        },
      });
      streaming.getAudioTracks()[0].enabled = false;
      const record = new RecordRTCPromisesHandler(streaming, {
        type: "video",
        mimeType: "video/webm;codecs=vp9",
      });
      await record.startRecording();
      setRecorder(record);
      setStream(streaming);
      setIntervals(setInterval(() => setTimer((timer) => timer + 1), 1000));
      setRecord(true);
    }
  };

  const stop = async () => {
    initStream.getTracks().forEach((track) => track.stop());
    clearInterval(interval);
    stream.stop();
    await recorder.stopRecording();
    const recordedBlob = await recorder.getBlob();
    setBlob(recordedBlob);
    dispatch({ type: "respond/saveVideo", payload: recordedBlob });
    setStream(null);
    setRecorder(null);
    setRecord(false);
  };

  const duration = recordDuration(timer);

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[15px] flex flex-col overflow-hidden">
      <nav className="w-full flex flex-row justify-center space-x-2 px-2 items-center py-2 ">
        <button
          className="w-[1.2rem] h-[1.5rem] lg:w-[1.5rem] aspect-square rounded-full bg-[#8DACCD54] border border-[#D1E6FC] flex flex-col "
          onClick={() => {
            initStream?.getTracks() &&
              initStream?.getTracks().forEach((track) => track.stop());

            props.back();
            dispatch({ type: "respond/reset" });
            dispatch({
              type: "qcast/currentQcast",
              payload: {
                currentVidIndex: 0,
              },
            });
          }}
        >
          <IoArrowBack className="m-auto w-full text-xs lg:text-sm fill-[#2C3037]" />
        </button>
        <p className="bg-[#FFFFFF80] text-[#515A6B] mr-5 backdrop-blur-[50px] px-6 rounded-full w-fit justify-self-end text-xs py-2 font-semibold whitespace-nowrap">
          Respond to Qcast
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full md:px-8 lg:px-[4rem] flex flex-col space-y-1 items-center pb-6 ">
        <div className="relative w-[122px] h-[122px] rounded-full overflow-hidden flex justify-center items-center">
          <CircularProgressbar
            value={vidInfo.currentTime || 0}
            maxValue={vidInfo.duration || 60}
            strokeWidth={4}
            styles={{
              trail: {
                stroke: `#FFF`,
              },
              path: {
                transition: "0ms",
              },
            }}
          />
          <div
            id="respond-video-record"
            className="w-[112px] h-[112px] rounded-full aspect-square flex flex-col bg-[#ECF5FC] shadow-md overflow-hidden m-0"
          >
            <Player
              src={currentQcast.listOfVideos[currentQcast.currentVidIndex]}
              className="rounded-full overflow-hidden"
              width={"100%"}
              height={"100%"}
              fluid={false}
              aspectRatio={"1:1"}
              ref={vidRef}
              autoPlay={record}
            >
              <ControlBar disableCompletely={true} />
            </Player>
          </div>
        </div>

        <span className="relative w-[270px] h-[270px] rounded-full overflow-hidden flex flex-col">
          <CircularProgressbar value={0} maxValue={60} strokeWidth={4} />
          <div
            className={`relative w-[250px] rounded-full aspect-square m-auto mt-[.6rem] flex flex-col bg-[#FFFFFFCC]`}
          >
            {startRecording && isMuted ? (
              <IoMicOffOutline className="w-8 h-8 text-white absolute z-10 left-[50%] top-[80%] transform -translate-x-[50%]" />
            ) : (
              <></>
            )}
            {blob ? (
              <Player
                src={window.URL.createObjectURL(blob)}
                className="rounded-full overflow-hidden m-auto transform scale-x-[-1]"
                fluid={false}
                width={250}
                aspectRatio={"1:1"}
              />
            ) : (
              <>
                {" "}
                <video
                  ref={videoRef}
                  muted
                  className="h-[250px] aspect-square rounded-full m-auto object-cover transform scale-x-[-1]"
                />
              </>
            )}
          </div>
        </span>
        <div className="w-[60%] bg-[#FFFFFFCC] shadow-md grid grid-cols-3 place-items-center rounded-3xl py-2 px-2 space-x-4">
          <p className="text-[#515A6B] text-xs lg:text-sm flex">
            {duration ? (
              duration.split("").map((t, idx) => (
                <span key={idx} className="w-[10px] inline-block text-center">
                  {t}
                </span>
              ))
            ) : (
              <>
                <span className="w-[10px] inline-block text-center">0</span>
                <span className="w-[10px] inline-block text-center">0</span>
                <span className="w-[10px] inline-block text-center">:</span>
                <span className="w-[10px] inline-block text-center">0</span>
                <span className="w-[10px] inline-block text-center">0</span>
              </>
            )}
          </p>

          <button
            onClick={async () => {
              if (!record) {
                await start();
                return;
              }
              await stop();
              props.reviewresponse();
            }}
            className="bg-gradient-to-b from-[#F1F9FF] to-[#DCE8F6] rounded-full p-1"
          >
            {record ? (
              <IoStop className="text-[#F88686] lg:h-[1.5em] lg:w-[1.5em]" />
            ) : (
              <IoStopCircleOutline className="text-[#F88686] lg:h-[1.5em] lg:w-[1.5em]" />
            )}
          </button>
          {record &&
          currentQcast?.listOfVideos.length >
            currentQcast.currentVidIndex + 1 ? (
            <button
              onClick={() => {
                dispatch({
                  type: "qcast/currentQcast",
                  payload: {
                    currentVidIndex: currentQcast.currentVidIndex + 1,
                  },
                });
                dispatch({
                  type: "respond/setAnswerIndex",
                  payload: timer * 1000,
                });
              }}
              className="bg-gradient-to-b from-[#F1F9FF] to-[#DCE8F6] rounded-full p-1"
            >
              <IoArrowForward
                style={{ color: bg }}
                className="text-sm lg:w-[1.3rem] lg:h-[1.3rem]"
              />
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Respond;
